import { gql } from '@apollo/client';

export default gql`
  query cancellationReasons {
    cancellationReasons {
      id
      content
    }
  }
`;
